(function (){
    'use strict';

    angular
        .module('app')
        .directive('countryRegionCities2', countryRegionCity);

    countryRegionCity.$inject = ['CountriesNewService'];

    function countryRegionCity(CountriesNewService) {
       var directive =  {
           restrict:'E',
           scope:{
               citiesSelected:'=items',
               labelField:'@label',
               arrayAuxCountry:'=countries',
               disabled:'=disabled',
               showTerritories:'=territories'
           },
           templateUrl: 'templates/directives/country/view/countryRegionCity2.html',
           link:link,
           controller:countryRegionCityCtrl,
           controllerAs: 'vm',
           bindToController: true
       };
       return directive;

       function link(scope, element, attrs, ctrl) {
            var countryList     = [];
            var vm = this;
            vm.disabled = false;
            vm.territorySelected = [];
            vm.countrySelected = [];
            vm.regionSelected = [];
            vm.arrayAuxCountry = [];
            
            if (scope.$last === true) {
               scope.$evalAsync(attr.countryRegionCities2);
           }
        }
    }

    countryRegionCityCtrl.$inject = ['CountriesNewService','$scope', '$compile','$timeout','$filter','$q'];

    function countryRegionCityCtrl(CountriesNewService, $scope, $compile, $timeout, $filter, $q) {
        var vm = this;
            vm.countrySelected   = {};
            vm.countryList       = [];
            vm.territoryList     = [];
            vm.regionSelected    = {};
            vm.citiesSelected    = {};
            vm.labelField        = 'Country';
            vm.disabled          = false;
            vm.arrayItems        = [];
            vm.arrayAuxCountry   = [];
            vm.arrayAuxRegions   = [];
            vm.regionList        = {};
            vm.cities            = {};
            vm.i                 = 0;
            vm.edit              = true;
            vm.selectCountries   = selectCountries;
            vm.selectTerritories = selectTerritories;
            vm.getCountryById    = getCountryById;
            vm.selectRegions     = selectRegions;
            vm.selectCities      = selectCities;
            vm.remove            = remove;
            vm.removeRegion      = removeRegion;
            vm.citySelected      = citySelected;
            vm.loadArrays        = loadArrays;
            vm.countrySelect     = countrySelect;
            vm.territorySelect   = territorySelect;
            

        function activate() {
            vm.selectTerritories();
            vm.selectCountries();
        }

        function selectCountries () {
            return CountriesNewService.getCountries().then(function(response){
                vm.countryList = response.data;
                
                if(typeof vm.citiesSelected !== 'undefined' && Object.keys(vm.citiesSelected).length !== 0) {
                    vm.loadArrays(vm.citiesSelected);
                } else {
                    vm.citiesSelected = {};
                }
            }).catch(function(err) {
            });
        }

        function selectTerritories () {
            return CountriesNewService.getTerritories().then(function(response){                
                vm.territoryList = response.data;
                
                if(typeof vm.citiesSelected !== 'undefined' && Object.keys(vm.citiesSelected).length !== 0) {
                    vm.loadArrays(vm.citiesSelected);
                } else {
                    vm.citiesSelected = {};
                }
            }).catch(function(err) {
            });
        }

        function getCountryById(countryId) {
            return CountriesNewService.getCountryById(countryId)
        }

        function territorySelect() {
            var territory_id = {};
            territory_id = angular.copy(vm.territorySelected.id);
            CountriesNewService.getCountriesByTerritoryId(territory_id).then(function(response) {
                let countries = response.data;
                countries.forEach(function(country) {
                    vm.countrySelected = country;
                    vm.countrySelect();
                });
            });
        }

        function countrySelect() {
            var country = vm.countrySelected;
            var item = {};
            item.country_name = angular.copy(country.name);
            item.country_id   = angular.copy(country.id);
            if(!vm.arrayItems[item.country_id]) {
                vm.arrayItems[item.country_id] = {};
                vm.arrayItems[item.country_id].country_name = item.country_name;
                vm.arrayItems[item.country_id].country_id = item.country_id;
                vm.arrayAuxCountry.push(item.country_id);
                if(!vm.citiesSelected[item.country_id]){
                    vm.citiesSelected[item.country_id] = {"id":item.country_id ,"name":item.country_name, regions:{"i":0}};
                }
            }
           vm.selectRegions();
        }

        function selectRegions () {
            var country_id = {};
            country_id = angular.copy(vm.countrySelected.id);
            CountriesNewService.getRegions(country_id).then(function(response){
                if(!vm.regionList[country_id]){
                    vm.regionList[country_id] = [];
                }
                if(!vm.regionSelected[country_id]){
                    vm.regionSelected[country_id] = {};
                }
                vm.regionList[country_id].push(response.data);
                vm.countrySelected = {};
            }).catch(function(err) {
            });
        }

        function loadArrays(citiesObj) {
            Object.keys(citiesObj).forEach(function(country) {
                if( country !== '') {
                    vm.getCountryById(country).then(function(response) {
                        vm.countrySelected = response.data[0];
                        vm.countrySelect();
                        Object.keys(citiesObj[country].regions).forEach(function (region) {
                                if (citiesObj[country].regions[region]) {
                                    vm.countrySelected.name = angular.copy(vm.countrySelected.name);
                                    vm.regionSelected.id = angular.copy(citiesObj[country].regions[region].id);
                                    vm.regionSelected.name = angular.copy(citiesObj[country].regions[region].name);
                                    vm.selectRegions();
                                    vm.selectCities(vm.countrySelected,vm.regionSelected);
                                }
                        });
                        vm.citiesSelected = JSON.parse(angular.toJson(citiesObj));
                    });
                }
            });
            console.log(vm.countrySelected);
            console.log(Object.keys(vm.countrySelected).length === 0);
        }

        function selectCities (country, region) {
            if(country.hasOwnProperty("country_id"))
                country.id = country.country_id;
            country = country ? angular.copy(country) : angular.copy(vm.countrySelected);
            region = region ? angular.copy(region) : angular.copy(vm.regionSelected);
            return CountriesNewService.getCities(country.id, region.id).then(function(response) {
                var item = [],
                    country_name = country.name,
                    country_id   = country.id,
                    region_name  = region.name,
                    region_id    = region.id;

                item = response.data.map(function (value) {
                    value.country_name = country_name;
                    value.country_id   = country_id;
                    value.region_name  = region_name;
                    value.region_id    = region_id;
                    return value;
                });

                if(!vm.arrayItems[country_id].regions) {
                    vm.arrayItems[country_id].regions = [];
                }

                if(!vm.citiesSelected[country_id].regions[region_id]) {
                    vm.citiesSelected[country_id].regions[region_id] = {"id":region_id, "name":region_name, "cities":[]};
                }

                if(!vm.arrayItems[country_id].regions[region.id]) {
                    vm.arrayItems[country_id].regions[region.id] = [];
                    vm.arrayItems[country_id].regions[region.id].push(item);
                    if(!vm.arrayAuxRegions[country_id]) {
                        vm.arrayAuxRegions[country_id] = [];
                    }
                    vm.arrayAuxRegions[country_id].push(region.id);
                }

                if(!vm.cities[country_id]) {
                    vm.cities[country_id] = {};
                }
                if(!vm.cities[country_id].regions) {
                    vm.cities[country_id].regions = [];
                }
                if(!vm.cities[country_id].regions[region.id]){
                    vm.cities[country_id].regions[region.id] = [];
                }
                vm.cities[country_id].regions[region.id] = response.data;
            }).catch(function(err) {
                return false;
            });
        }
        function remove(item) {
            $timeout(function(){
                delete vm.cities[item];
                delete vm.arrayAuxRegions[item];
                delete vm.citiesSelected[item];
                if(Object.keys(vm.citiesSelected).length === 0){
                    vm.citiesSelected = {};
                }

                vm.arrayAuxCountry.splice(vm.arrayAuxCountry.indexOf(item), 1);
                delete vm.arrayItems[item];
            }, 0);
        }

        function removeRegion(arrRegion, arrCities, data, item) {
            $timeout(function(){
                delete vm.cities[item].regions[data];
                delete vm.arrayItems[item].regions[data];
                delete vm.citiesSelected[item].regions[data];
                if(vm.arrayAuxRegions[item].splice(vm.arrayAuxRegions[item].indexOf(data), 1)){
                    delete arrRegion[data];
                }
            }, 0);
        }

        function citySelected(selectedItem, model) {
        }
        activate();
        
    }
})();